import React, {Component} from 'react';
import loginLogo from '../../images/login-logo.png'
import {UserService} from '../../lib/qc-api-client';
import Alert from 'sweetalert-react';

export default class ForgotPassword extends Component {

    constructor(props) {
      super(props)
      this.state = {
        email: '',
        is_submitted: false
      }
    }

    onKeyDown = (event) => {
      if (event.key === 'Enter') {
        this.handleSubmit();
      }
    }

    handleSubmit = () => {
      if(this.state.email === '')
        return;

      this.setState({
      	is_submitted: true
      })
      UserService.forgotPassword(this.state.email)
        .then((response) => {
          this.setState({
            showLoginAlert: true,
            is_submitted: false,
            alertType: 'success',
            alertMessage: 'Reset email is sent to your email address'
          });
        })
        .catch((error) => {
          this.setState({
            showLoginAlert: true,
            is_submitted: false,
            alertType: 'error',
            alertMessage: error.response.data.message,
          });
        })
    }

    handleChange = (event) => {
      let name = event.target.name;
      let value = event.target.value
      this.setState({ [name]: value })
    }

    render() {
        const styles = {
          container: {
            width: 1020,
            margin: '0 auto'
          },

          logo: {
            width: 238,
            margin: '62px auto 100px',
            padding: 0
          },

          login: {
            width: 515,
            padding: '85px 80px',
            margin: '0 auto',
            backgroundColor: '#fff',
            h1: {
              width: '100%',
              float: 'left',
              margin: '0 0 10px',
              padding: 0,
              fontSize: 28,
              color: '#39b54a',
              fontWeight: 400
            },
            formControl: {
              borderColor: '#8290a2',
              height: 45,
              color: '#8290a2',
              marginBottom: 10
            },
            p: {
              width: '100%',
              float: 'left',
              margin: 0,
              padding:0,
              color: '#8290a2',
              fontSize: 14
            },
            btn: {
              width: '100%',
              float: 'left',
              margin: '0 0 10px',
              backgroundColor: '#39b54a',
              color: '#fff',
              padding: '12px 0',
              textAlign: 'center',
              fontSize: 18,
              fontWeight: 700,
              borderRadius: 4,
              WebkitTransition: 'all .2s ease-in-out',
              OTransition: 'all .2s ease-in-out',
              transition: 'all .2s ease-in-out'
            }
          }
        }

        return (
            <div className="login_container clearfix" style={styles.container} >
              <div className="login_logo" style={styles.logo}>
                <a href="/"><img src={loginLogo} alt=""/></a>
              </div>
              <div className="login_main clearfix" style={styles.login}>
                <form name="usersignin">
                  <input
                    type="email"
                    value={this.state.email}
                    onChange={this.handleChange}
                    onKeyDown={this.onKeyDown}
                    style={styles.login.formControl}
                    className="form-control"
                    name="email"
                    placeholder="Email"
                    required
                  />

                  <input type="button" disabled={this.state.is_submitted} style={styles.login.btn} onClick={this.handleSubmit} className="btn_signin" value="Submit"/>
                </form>
              </div>

              <Alert
                show={this.state.showLoginAlert}
                title="Email Sent"
                text={this.state.alertMessage}
                type={this.state.alertType}
                onConfirm={() => this.setState({ showLoginAlert: false })}
              />

            </div>
        )
    }
}
